import { render, staticRenderFns } from "./UserDetailsPage.vue?vue&type=template&id=56004806&scoped=true"
import script from "./UserDetailsPage.vue?vue&type=script&lang=js"
export * from "./UserDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./UserDetailsPage.vue?vue&type=style&index=0&id=56004806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56004806",
  null
  
)

export default component.exports